export default __webpack_public_path__ + "static/appearance-f5d09262e3fcebdea23c7f46d409a255.gif";